import * as React from "react"
import { useHistory } from "react-router-dom"
import Popover from "@mui/material/Popover"
import Button from "@mui/material/Button"
import SchoolIcon from "@mui/icons-material/School"
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material"

import { DE_AVAILABLE_STATES, landingPageMeta } from "./drivers-ed/content"
import StateSelect from "./StateSelect"
import RoundedCard from "./product-marketing/RoundedCard"

const DriversEdMenuPopover = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const [selectedState, setSelectedState] = React.useState<string | null>(null)
  const isOpen = Boolean(anchorEl)
  const history = useHistory()

  const openPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const closePopover = () => {
    setSelectedState("")
    setAnchorEl(null)
  }

  const submitForm = () => {
    if (!selectedState) return
    // this 'ca' check is being hard-coded for testing purposes and can be
    // updated/removed when we have results - BH 8/4/23
    if (selectedState === "ca") {
      history.push("/ca/course/drivers-ed")
    } else if (landingPageMeta[selectedState].length > 1) {
      history.push(`/courses?state=${selectedState}`)
    } else {
      const { courseType } = landingPageMeta[selectedState][0]
      history.push(`/${selectedState}/course/${courseType}`)
    }
  }

  return (
    <>
      <Button
        variant="contained"
        onClick={openPopover}
        endIcon={isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        className="button-cta"
        data-cy="drivers-ed-cta"
      >
        <SchoolIcon style={{ marginRight: 10 }} />
        Drivers Ed
      </Button>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={closePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <RoundedCard>
          <StateSelect
            label="Select Your State"
            availableStates={DE_AVAILABLE_STATES}
            onSelectedCallback={(state) => {
              setSelectedState(state.toLowerCase())
            }}
            selectedState={selectedState?.toUpperCase()}
            marginTop={0}
          />
          <br />
          <Button
            onClick={submitForm}
            variant="contained"
            style={{ marginTop: 15 }}
            disabled={!selectedState}
          >
            View Course
          </Button>
        </RoundedCard>
      </Popover>
    </>
  )
}

export default DriversEdMenuPopover
